import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiProcedimientosService } from '../../../services/api-procedimientos.service';
import { Globals } from 'src/app/globals';
declare var $: any;
@Component({
  selector: 'app-procedimientos',
  templateUrl: './procedimientos.component.html',
  styleUrls: ['./procedimientos.component.css']
})
export class ProcedimientosComponent implements OnInit {

  pantalla = 1;
  anio = Number(new Date().getFullYear());
  proveedor;

  registros: any [] = [];

  public mensajeError: string = '¡Error!';

  constructor(private router: Router, private apiProc: ApiProcedimientosService, public globals: Globals) {
  }

  ngOnInit() {
    $('#mod_procesando').modal('show');
    this.cargaDatos();
  }

  cargaDatos() {
    this.apiProc.getListaProcs(this.anio.toString(), this.pantalla, null, null).subscribe(data => {
      if (data[0].success) {
        if(data[0].info !== '{}' && data[0].info !== '[]'){
           let datos = JSON.parse(data[0].info);
           this.registros = datos;
           setTimeout( () => {
            $('#mod_procesando').modal('hide');
          },500);
        } else {
          setTimeout( () => {
            $('#mod_procesando').modal('hide');
          },500);
        }
        setTimeout( () => {
          $('#mod_procesando').modal('hide');
        },500);
      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout( () => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        },500);
      }
      this.cargaDatatable();
    },
    error => {
      setTimeout( () => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      },500);
    });
  }

  cargaDatatable() {
    let tipoServicios = this.globals.TIPO_PROC_SERVICIOS;
    let tipoObra = this.globals.TIPO_PROC_OBRA;

    $(document).ready(function () {
    let datatable = $('#example').DataTable({
      /*dom: "<'row'<'col-sm-12 col-md-6'l>>" +
          "<'row'<'col-sm-12'tr>>" +
          "<'row'<'col-sm-12 col-md-6'><'col-sm-12 col-md-6'p>>",*/
       //dom: '<"#positionFilter">ltp',
       paging: true,       //Oculta controles y etiquetas de paginación
       searching: true,    //Dejar en true para conservar funcionalidades de busqueda en columnas.
       info: false,        //Oculta etiquetas de cantidad de registros disponibles y filtrados.
       autoWidth: false,   //Impide que calcule automaticamente el ancho de las columnas.
       processing: true,
       bSort: false,
       renderer: 'bootstrap',
       dom: "<'row'<'col-sm-10'B><'col-sm-2'>>tp",
       "lengthMenu": [[10, 25, 50, -1], ["Mostrar 10", "Mostrar 25", "Mostrar 50", "Mostrar Todos"]],
       language: {
         "sSearch": "Buscar:",
         "sProcessing": "Procesando...",
         "sLengthMenu": "_MENU_ REGISTROS",
         "sZeroRecords": "No se encontraron resultados",
         "sEmptyTable": "Ningún dato disponible en esta tabla",
         "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
         "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
         "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
         "sInfoPostFix": "",
         "oPaginate": {
             "sFirst": "Primero",
             "sLast": "Último",
             "sNext": "SIGUIENTE",
             "sPrevious": "ANTERIOR"
         },
         buttons: {
             pageLength: {
                 _: '<span><i class="fal fa-list-ul mr-2"></i></span> %d REGISTROS',
                 //1: '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos',
                 '-1': '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos'
             }
         }
     },
     buttons: [
           {
             extend: 'pageLength',
             className: 'btn uaa-btn-outline btn-sm dropdown-toggle'
         }
     ],
      "columnDefs": [
        { "searchable": true, "targets": 7 },
        { "visible": false, "targets": 7 }
      ]
    });

    $('#inputBusqueda').on( 'keyup', function () {
      datatable.search( this.value ).draw();
    });

    $('#todos').on('change', function() {
      if( $(this).is(':checked') ) {
          $('#productos').prop('checked', false);
          $('#obra').prop('checked', false);
          datatable.columns(7).search('');
      } else {
        datatable.columns(7).search('');
      }
      datatable.draw();
    });


    $('#productos').on('change', function() {
      if( $(this).is(':checked') ) {
          $('#todos').prop('checked', false);
          $('#obra').prop('checked', false);
          datatable.columns(7).search(tipoServicios);
      } else {
        datatable.columns(7).search('');
      }
      datatable.draw();
    });

    $('#obra').on('change', function() {
      if( $(this).is(':checked') ) {
          $('#todos').prop('checked', false);
          $('#productos').prop('checked', false);
          datatable.columns(7).search(tipoObra);
      } else {
        datatable.columns(7).search('');
      }
      datatable.draw();
    });
    });


  }

  detalle(anio: string, numsol: string, iactido: string) {
    if (iactido === 'OBRAPUB') {
      this.router.navigate(['/procedimientos-det-obra', anio, numsol]);
    } else if (iactido === 'ADQUISICION') {
      this.router.navigate(['/procedimientos-detalle', anio, numsol]);
    }
  }

}
